import {type StateCreator} from 'zustand'
import {type UIGameCardAnimatorItemProps} from '../../core/UIGameCardAnimator/utils.ts'
import {type GameStoreType} from '../gameStore.ts'

export interface GameCardAnimatorSlice {
    gameCardAnimator: {
        cardsAnimating: UIGameCardAnimatorItemProps[]
        setCardsAnimating: (cardsAnimating: UIGameCardAnimatorItemProps[]) => void
        addCard: (card: UIGameCardAnimatorItemProps) => void
        removeCard: (id: number) => void
        forceAnimationComplete: (id: number) => void
    }
}

export const createGameCardAnimatorSlice = (): StateCreator<GameStoreType, [], [], GameCardAnimatorSlice> => (set, get, api) => ({
    gameCardAnimator: {
        cardsAnimating: [],
        setCardsAnimating: (cardsAnimating: UIGameCardAnimatorItemProps[]) => {
            set({gameCardAnimator: {
                ...get().gameCardAnimator,
                cardsAnimating: cardsAnimating,
            }})
        },
        addCard: (card: UIGameCardAnimatorItemProps) => {
            if(!get().gameUserSettings.isAnimationsEnabled) {
                card.onComplete?.(0)
                return
            }
            set({gameCardAnimator: {
                ...get().gameCardAnimator,
                cardsAnimating: [...get().gameCardAnimator.cardsAnimating, card],
            }})
        },
        removeCard: (id: number) => {
            set({gameCardAnimator: {
                ...get().gameCardAnimator,
                cardsAnimating: get().gameCardAnimator.cardsAnimating.filter((card) => card.id !== id),
            }})
        },
        forceAnimationComplete: (id: number) => {
            const cardAnimating = get().gameCardAnimator.cardsAnimating.find((card) => card.id === id)
            if(cardAnimating) cardAnimating.onComplete?.(cardAnimating.id)
        },
    },
})
